export default __webpack_public_path__ + "static/media/bluemarlin.bb9893b1.jpg";